import React from 'react';
import cn from 'classnames';

var styles = {"component":"status__component_53v0f","soft":"status__soft_53v0f","green":"status__green_53v0f","orange":"status__orange_53v0f","red":"status__red_53v0f","blue":"status__blue_53v0f","grey":"status__grey_53v0f","teal":"status__teal_53v0f","purple":"status__purple_53v0f","contrast":"status__contrast_53v0f"};
require('./index.css');

var colors = ['green', 'orange', 'red', 'blue', 'grey', 'teal', 'purple'];
var Status = function (_a) {
    var className = _a.className, _b = _a.view, view = _b === void 0 ? 'soft' : _b, _c = _a.color, color = _c === void 0 ? 'green' : _c, children = _a.children, dataTestId = _a.dataTestId;
    return (React.createElement("span", { className: cn(styles.component, styles[color], styles[view], className), "data-test-id": dataTestId }, children));
};

export { Status, colors };
